// extracted by mini-css-extract-plugin
export default {"container":"index_container__Y3vvP","pairContainer":"index_pairContainer__vQLYM","item":"index_item__gjmUr"};